import { formatDate } from 'commons/utils/date'

import type {
  SalesCalendarCreateItemPayload,
  SalesCalendarCreateItemPayloadApi,
  SalesCalendarEditItemPayload,
  SalesCalendarEditItemPayloadApi,
  SalesCalendarEditParams,
  SalesCalendarEditParamsApi,
  SalesCalendarListItem,
  SalesCalendarListItemApi,
  SalesCalendarListParams,
  SalesCalendarListParamsApi,
  SalesCalendarListResponse,
  SalesCalendarListResponseApi,
  SalesCalendarTrackingItem,
  SalesCalendarTrackingItemApi,
  SalesCalendarTrackingPayload,
  SalesCalendarTrackingPayloadApi,
  SalesCalendarTrackingResponse,
  SalesCalendarTrackingResponseApi,
} from './interfaces'

export const toSalesCalendarListParamsApi = (
  params: SalesCalendarListParams,
): SalesCalendarListParamsApi => ({
  escritorio: params.officeCode,
  page: params.page,
  perPage: params.perPage,
})

export const toSalesCalendarListItem = (item: SalesCalendarListItemApi): SalesCalendarListItem => ({
  endDateApproval: item.dataFinalAprovacao,
  endDateHava: item.dataFinalHava,
  endDatePortal: item.dataFinalPortal,
  initialDateApproval: item.dataInicialAprovacao,
  initialDateHava: item.dataInicialHava,
  initialDatePortal: item.dataInicialPortal,
  officeCode: item.codigoEscritorioVenda,
  yearMonth: item.anoMes,
})

export const toSalesCalendarListResponse = (
  response: SalesCalendarListResponseApi,
): SalesCalendarListResponse => ({
  ...response,
  data: response.data ? response.data.map(toSalesCalendarListItem) : [],
})

export const toSalesCalendarCreateItemPayloadApi = (
  payload: SalesCalendarCreateItemPayload,
): SalesCalendarCreateItemPayloadApi => {
  return {
    AnoMes: payload.fairShareMonth,
    DataFinalAprovacao: payload.approvalEndDate,
    DataFinalHava: payload.havaEndDate,
    DataFinalPortal: payload.portalEndDate,
    DataInicialAprovacao: payload.approvalBeginDate,
    DataInicialHava: payload.havaBeginDate,
    DataInicialPortal: payload.portalBeginDate,
    Escritorio: payload.officeCode,
  }
}

export const toSalesCalendarEditParamsApi = (
  params: SalesCalendarEditParams,
): SalesCalendarEditParamsApi => {
  return {
    anoMes: params.yearMonth,
    escritorio: params.officeCode,
  }
}

export const toSalesCalendarEditItemPayloadApi = (
  payload: SalesCalendarEditItemPayload,
): SalesCalendarEditItemPayloadApi => {
  return {
    DataFinalAprovacao: payload.approvalEndDate,
    DataFinalHava: payload.havaEndDate,
    DataFinalPortal: payload.portalEndDate,
    DataInicialAprovacao: payload.approvalBeginDate,
    DataInicialHava: payload.havaBeginDate,
    DataInicialPortal: payload.portalBeginDate,
  }
}

export const toSalesCalendarTrackingPayloadApi = (
  payload: SalesCalendarTrackingPayload,
): SalesCalendarTrackingPayloadApi => {
  return {
    anoMes: payload.yearMonthList,
    escritorio: payload.office,
  }
}

export const toSalesCalendarTrackingItem = (
  item: SalesCalendarTrackingItemApi,
): SalesCalendarTrackingItem => ({
  action: item.acao,
  description: item.descricao,
  formattedDate: item.dataAlteracao ? formatDate(item.dataAlteracao, 'DD/MM/YYYY') : '',
  formattedTime: item.dataAlteracao ? formatDate(item.dataAlteracao, 'HH[h]mm') : '',
  formattedYearMonth:
    item.mes && item.ano
      ? formatDate(`${item.ano}${String(item.mes).padStart(2, '0')}`, 'MM/YYYY', 'YYYYMM')
      : '',
  month: item.mes,
  officeCode: item.codigoEscritorioVenda,
  updateDate: item.dataAlteracao,
  username: item.usuarioCadastro,
  year: item.ano,
})

export const toSalesCalendarTrackingResponse = (
  response: SalesCalendarTrackingResponseApi,
): SalesCalendarTrackingResponse => ({
  ...response,
  data: response.data ? response.data.map(toSalesCalendarTrackingItem) : [],
})
